"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LoadingCarousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoadingCarousel, _React$Component);

  function LoadingCarousel() {
    _classCallCheck(this, LoadingCarousel);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingCarousel).apply(this, arguments));
  }

  _createClass(LoadingCarousel, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        id: "contain"
      }, _react["default"].createElement("div", {
        className: this.props.theme.inner
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.wrap, this.props.theme.wrap1),
        id: "wrap1"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.ball, this.props.theme.wrap1),
        id: "ball1"
      })), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.wrap, this.props.theme.wrap2),
        id: "wrap2"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.ball, this.props.theme.ball2),
        id: "ball2"
      })), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.wrap, this.props.theme.wrap3),
        id: "wrap3"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.ball, this.props.theme.ball3),
        id: "ball3"
      })), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.wrap, this.props.theme.wrap4),
        id: "wrap4"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.ball, this.props.theme.ball4),
        id: "ball4"
      }))));
    }
  }]);

  return LoadingCarousel;
}(_react["default"].Component);

var _default = (0, _ThemeProvider.applyTheme)('LoadingCarousel', LoadingCarousel);

exports["default"] = _default;